import { Location } from '@angular/common';
import { Component, HostListener, inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { filter, firstValueFrom } from 'rxjs';
import { AuthenticationContants } from 'src/app/constants/authentication-constants';
import { ProjectName } from 'src/app/constants/project-name-constants';
import { AdvanceInvoiceStateEnums } from 'src/app/enum/advance-invoice-state-enum';
import { BussinessDocumentsClassEnums } from 'src/app/enum/bussiness-documets-class-enums';
import { ClientStateEnums } from 'src/app/enum/client-state-enums';
import { CostCenterEnums } from 'src/app/enum/cost-center-enums';
import { ElectronicDocumentEnums } from 'src/app/enum/electronic-document-enums';
import { WindowEnums } from 'src/app/enum/window-enums';
import { CustomListDropdown } from 'src/app/interfaces/custom-list/custom-list-dropdown.interface';
import { OptionWindowModel } from 'src/app/models/authentication/option-window.model';
import { UserModel } from 'src/app/models/authentication/user.model';
import { AdvanceInvoiceModel } from 'src/app/models/invoicing/advance-invoice.model';
import { BranchModel } from 'src/app/models/management/branch.model';
import { CostCenterService } from 'src/app/services/archive/cost-center.service';
import { SellerService } from 'src/app/services/archive/seller.service';
import { OptionWindowService } from 'src/app/services/authentication/option-window.service';
import { WindowService } from 'src/app/services/authentication/window.service';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog/confirm-dialog.service';
import { DateConverterService } from 'src/app/services/global-services/date-converter.service';
import { FormControlStateService } from 'src/app/services/global-services/form-control-state.service';
import { UserAuthenticatedService } from 'src/app/services/global-services/user-authenticated.service';
import { HeaderService } from 'src/app/services/header/header.service';
import { AdvanceInvoiceConceptService } from 'src/app/services/invoicing/advance-invoice-concept.service';
import { AdvanceInvoiceService } from 'src/app/services/invoicing/advance-invoice.service';
import { InvoiceService } from 'src/app/services/invoicing/invoice.service';
import { BranchService } from 'src/app/services/management/branch.service';
import { BussinessDocumentsTypeService } from 'src/app/services/management/bussiness-documents-type.service';
import { EnterpriseService } from 'src/app/services/management/enterprise.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';

@Component({
  selector: 'app-register-advance-invoice',
  templateUrl: './register-advance-invoice.component.html',
  styleUrls: ['./register-advance-invoice.component.scss'],
  standalone: false
})
export class RegisterAdvanceInvoiceComponent implements OnInit {

  private readonly activatedRoute = inject(ActivatedRoute);
  private readonly advanceInvoiceConceptService = inject(AdvanceInvoiceConceptService);
  private readonly advanceInvoiceService = inject(AdvanceInvoiceService);
  private readonly branchService = inject(BranchService);
  private readonly bussinessDocumentsTypeService = inject(BussinessDocumentsTypeService);
  private readonly confirmDialogService = inject(ConfirmDialogService);
  private readonly costCenterService = inject(CostCenterService);
  private readonly dateConverterService = inject(DateConverterService);
  private readonly enterpriseService = inject(EnterpriseService);
  private readonly formBuilder = inject(FormBuilder);
  private readonly formControlStateService = inject(FormControlStateService);
  private readonly headerService = inject(HeaderService);
  private readonly invoiceService = inject(InvoiceService);
  private readonly location = inject(Location);
  private readonly optionWindowService = inject(OptionWindowService);
  private readonly router = inject(Router);
  private readonly sellerService = inject(SellerService);
  private readonly title = inject(Title);
  private readonly toastHandlerService = inject(ToastHandlerService);
  private readonly userAuthenticatedService = inject(UserAuthenticatedService);
  private readonly windowService = inject(WindowService);

  advanceInvoiceContract: AdvanceInvoiceModel = new AdvanceInvoiceModel();
  advanceInvoiceId: number;
  advanceInvoiceStateString: string = '';
  ascendant: boolean = true;
  branchId: number = 0;
  bussinessDocumentsTypeId: number = BussinessDocumentsClassEnums.factura;
  bussinessDocumentsTypeIsRental: string = '';
  classInputClient: string = '';
  classInputCostCenter: string = '';
  clientId: number = 0;
  columnSort: string | null = null;
  companyId: number = 0;
  disabledForm: boolean = false;
  enterpriseId: number = 0;
  filteredCostCenters: any[] = [];
  formAdvanceInvoiceFirst: FormGroup = new FormGroup({});
  formAdvanceInvoiceFooter: FormGroup = new FormGroup({});
  iconStateAdvanceInvoice: string = "lock_open";
  invoicingCutoffCode: number | string = '';
  isFormView: boolean = false;
  isOpened: string | undefined = undefined;
  limit: number = 10;
  listBranches: any[] = [];
  listBussinessDocumentsTypes: any[] = [];
  listClients: CustomListDropdown[] = [];
  listCostCenters: any[] = [];
  listEnterprises: CustomListDropdown[] = [];
  listSellers: any[] = [];
  listZones: any[] = [];
  mainBranchByUser: BranchModel = new BranchModel();
  messageStateAdvanceInvoice: string = "";
  nameWindow: string = 'Captura Facturas Anticipadas';
  page: number = 1;
  permissionsUser: Array<OptionWindowModel> = new Array<OptionWindowModel>();
  permissionUpdatable: boolean = false;
  projectName = ProjectName.projectName;
  quantityDetails: number = 0;
  severityState: string = "danger";
  showAccordion: boolean = false;
  showAllCostCenter: number = CostCenterEnums.Todos;
  stateClientId: number | null = 0;
  stateCostCenterId: number = 0;
  titleStateAdvanceInvoice: string = "";
  updateListDetail: boolean = false;
  url: string = "advance-invoice";
  userAuthenticated: UserModel = new UserModel();

  async ngOnInit() {
    this.validateForm(this.advanceInvoiceContract);
    this.headerService.setTitle(this.nameWindow);
    this.title.setTitle(`${this.nameWindow} - ${this.projectName}`);
    await this.getPermission();
    this.activatedRoute.params.subscribe(params => {
      this.advanceInvoiceId = Object.keys(params).length > 0 ? params?.id : null;
    });
    this.handleInitialState();
  }

  @HostListener('window:beforeunload')
  beforeUnloadHandler() {
    this.ngOnDestroy();
  }

  async ngOnDestroy() {
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      const window = windowsOpened.findIndex(x => x === this.url);
      if (window != -1) {
        windowsOpened.splice(window, 1);
        localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      }
    }
  }

  async changeBranch(branchId: number, loadAllLists: boolean) {
    this.branchId = branchId;
    if (loadAllLists) {
      await this.getAllLists();
    } else {
      await this.getFirstEnterpriseByBranch();
      await this.getAllLists('enterprises', 'costCenters', 'sellers', 'zones', 'bussinessDocumentsTypes');
    }
  }

  changeBussinessDocumentsType() {
    this.branchId = this.formAdvanceInvoiceFirst.get("branchId")?.value;
    this.enterpriseId = this.formAdvanceInvoiceFirst.get("enterpriseId")?.value;
    this.bussinessDocumentsTypeId = this.formAdvanceInvoiceFirst.get("bussinessDocumentsTypeId")?.value;
  }

  async changeConsecutive() {
    let consecutive = this.formAdvanceInvoiceFirst.get("consecutive")?.value;
    if (this.advanceInvoiceContract.invoice.consecutive == consecutive) return;
    const branchId = this.formAdvanceInvoiceFirst.get("branchId")?.value;
    const enterpriseId = this.formAdvanceInvoiceFirst.get("enterpriseId")?.value;
    const bussinessDocumentsTypeId = this.formAdvanceInvoiceFirst.get("bussinessDocumentsTypeId")?.value;

    if (branchId == null || branchId == 0) {
      this.toastHandlerService.showToast(
        'warning',
        'Seleccione una sucursal.'
      );
      return;
    } else if (enterpriseId == null || enterpriseId == 0) {
      this.toastHandlerService.showToast(
        'warning',
        'Seleccione una Empresa.'
      );
      return;
    } else if (bussinessDocumentsTypeId == null || bussinessDocumentsTypeId == 0) {
      this.toastHandlerService.showToast(
        'warning',
        'Seleccione un Tipo de Documento Comercial.'
      );
      return;
    } else if (consecutive == 0) {
      consecutive = null;
    }

    if (consecutive == null) {
      this.advanceInvoiceId = 0;
      const modelAdvanceInvoice = new AdvanceInvoiceModel();
      modelAdvanceInvoice.branchId = branchId;
      modelAdvanceInvoice.invoice.enterpriseId = enterpriseId;
      modelAdvanceInvoice.invoice.bussinessDocumentsTypeId = bussinessDocumentsTypeId;
      this.advanceInvoiceContract = modelAdvanceInvoice;
    } else {
      try {
        this.advanceInvoiceContract = await firstValueFrom(
          this.advanceInvoiceService.getAdvanceInvoiceByKeysAsync(branchId, enterpriseId, bussinessDocumentsTypeId, consecutive)
        );
        this.advanceInvoiceId = this.advanceInvoiceContract.advanceInvoiceId;
        this.validateForm(this.advanceInvoiceContract);
        this.location.replaceState(`/advance-invoice/register/${this.advanceInvoiceId}`);
      } catch (error) {
        this.clearForm();
        console.error('Error al buscar la factura anticipada por llaves.', error);
      }
    }
  }

  async changeEnterprise(enterpriseId: number) {
    this.branchId = this.formAdvanceInvoiceFirst.get("branchId")?.value;
    this.enterpriseId = enterpriseId;
    await Promise.all([
      this.getFirstBussinessDocumentsType(),
      this.getAllLists('bussinessDocumentsTypes'),
    ]);
  }

  async changeStateAdvanceInvoice() {
    if (this.advanceInvoiceContract.invoice.consecutive == 0) {
      this.toastHandlerService.showToast('warning', 'La factura anticipada no existe.');
      return;
    }
    if (this.permissionUpdatable) {
      if (this.advanceInvoiceContract.advanceInvoiceState == AdvanceInvoiceStateEnums.open) {
        this.titleStateAdvanceInvoice = "Cerrar";
        this.messageStateAdvanceInvoice = "¿Realmente desea cerrar la factura anticipada?";
      } else {
        this.titleStateAdvanceInvoice = "Abrir";
        this.messageStateAdvanceInvoice = "¿Realmente desea abrir la factura anticipada?";
      }

      const accepted = await this.confirmDialogService.confirm(this.messageStateAdvanceInvoice);
      if (accepted) {
        await firstValueFrom(this.advanceInvoiceService.setStateAdvanceInvoice(this.advanceInvoiceContract.advanceInvoiceId));
        await this.getAdvanceInvoiceById();
        this.toastHandlerService.showToast(
          'success',
          'El estado de la factura anticipada se modificó exitosamente.'
        );
      }
    } else {
      this.toastHandlerService.showToast(
        'error',
        'El usuario no tiene permisos para cambiar estados de Facturas Anticipadas. Comuníquese con el administrador del sistema.'
      );
    }
  }

  clearForm() {
    const branchId = this.formAdvanceInvoiceFirst.get("branchId")?.value;
    const enterpriseId = this.formAdvanceInvoiceFirst.get("enterpriseId")?.value;
    const bussinessDocumentsTypeId = this.formAdvanceInvoiceFirst.get("bussinessDocumentsTypeId")?.value;
    const consecutive = this.formAdvanceInvoiceFirst.get("consecutive")?.value;

    const modelAdvanceInvoice = new AdvanceInvoiceModel();
    modelAdvanceInvoice.advanceInvoiceId = -1;
    modelAdvanceInvoice.branchId = branchId;
    modelAdvanceInvoice.invoice.enterpriseId = enterpriseId;
    modelAdvanceInvoice.invoice.bussinessDocumentsTypeId = bussinessDocumentsTypeId;
    modelAdvanceInvoice.invoice.consecutive = consecutive;
    this.advanceInvoiceContract = modelAdvanceInvoice;
    this.invoicingCutoffCode = '';
    this.validateForm(this.advanceInvoiceContract);
    this.location.replaceState(`/advance-invoice/register`);
  }

  async editAdvanceInvoice() {
    await this.getAdvanceInvoiceById();
  }

  filterCostCenterByClientId(clientId: number | null) {
    const rowsFiltered = this.listCostCenters.filter(cc => cc.clientId == clientId);
    if (clientId != null) {
      this.filteredCostCenters = rowsFiltered;
      const costCenterId = this.formAdvanceInvoiceFirst.get("costCenterId")?.value;
      const costCenterClient = this.listCostCenters.find(x => x.clientId == clientId);
      if ((costCenterId && costCenterClient) && costCenterClient.value != costCenterId) {
        this.formAdvanceInvoiceFirst.controls["costCenterId"].patchValue(null);
      }
    } else {
      this.filteredCostCenters = this.listCostCenters;
    }
  }

  async getAdvanceInvoiceById() {
    try {
      const response = await firstValueFrom(this.advanceInvoiceService.getAdvanceInvoiceById(this.advanceInvoiceId));
      this.bussinessDocumentsTypeId = response.invoice.bussinessDocumentsTypeId;
      this.enterpriseId = response.invoice.enterpriseId;
      this.advanceInvoiceContract = response;
      await this.changeBranch(response.branchId, true);
      this.validateForm(this.advanceInvoiceContract);
    } catch (error) {
      console.error('Error al buscar la factura anticipada por id.', error);
    }
  }

  async getAllLists(...listsToLoad: Array<'branches' | 'enterprises' | 'clients' | 'costCenters' | 'bussinessDocumentsTypes' | 'sellers' | 'zones'>) {
    try {
      const lists = {
        branches: async () => {
          this.listBranches = await firstValueFrom(
            this.branchService.getAllBranchesForSelectAsync()
          );
        },
        enterprises: async () => {
          this.listEnterprises = await firstValueFrom(
            this.enterpriseService.getEnterprisesByBranchIdForSelect(this.branchId)
          );
        },
        clients: async () => {
          this.listClients = await firstValueFrom(
            this.invoiceService.getAllClientsForSelectAsync()
          );
        },
        costCenters: async () => {
          this.listCostCenters = await firstValueFrom(
            this.invoiceService.getAllCostCenterByBranchIdForSelect(this.branchId)
          );
          this.filteredCostCenters = this.listCostCenters;
        },
        bussinessDocumentsTypes: async () => {
          this.listBussinessDocumentsTypes = await firstValueFrom(
            this.invoiceService.getAllBussinessDocumentsTypesForSelectAsync(this.branchId, this.enterpriseId)
          );
        },
        sellers: async () => {
          this.listSellers = await firstValueFrom(
            this.sellerService.getAllSellersForSelectByBranchIdAsync(this.branchId)
          );
        },
        zones: async () => {
          this.listZones = await firstValueFrom(
            this.invoiceService.getAllZonesByBranchIdForSelects(this.branchId)
          );
        },

      };
      if (listsToLoad.length) {
        await Promise.all(listsToLoad.map(list => lists[list]()));
      } else {
        await Promise.all([
          lists.zones(),
          lists.sellers(),
          lists.clients(),
          lists.branches(),
          lists.enterprises(),
          lists.costCenters(),
          lists.bussinessDocumentsTypes()
        ]);
      }
      return true;
    } catch (error) {
      console.error('Error al obtener las listas.', error);
      return false;
    }
  }

  async getBranch(branchId: number, reload: boolean) {
    try {
      const branch = await firstValueFrom(this.branchService.getBranchById(branchId));
      this.branchId = branch.branchId;
      if (reload) {
        await this.changeBranch(branch.branchId, false);
      }
    } catch (error) {
      console.error('Error al obtener la sucursal.', error);
    }
  }

  getBussinessDocumentsType(bussinessDocumentsTypeId: number | null, reload: boolean) {
    if (bussinessDocumentsTypeId != null && bussinessDocumentsTypeId != 0) {
      const bussinessDocumentsType = this.listBussinessDocumentsTypes.find(x => x.value == bussinessDocumentsTypeId);
      if (bussinessDocumentsType) {
        this.bussinessDocumentsTypeId = bussinessDocumentsTypeId;
        const isRental = bussinessDocumentsType.isRental === true;
        isRental ? this.bussinessDocumentsTypeIsRental = 'Alquiler' : this.bussinessDocumentsTypeIsRental = 'Venta';
        if (bussinessDocumentsType.bussinessDocumentsDianTypeId == ElectronicDocumentEnums.tipoDianFacturaExportacion) {
          this.showAllCostCenter = CostCenterEnums.CcoMonedaDiferente;
        } else {
          this.showAllCostCenter = CostCenterEnums.Todos;
        }
      } else {
        this.showAllCostCenter = CostCenterEnums.Todos;
        return;
      }
    } else {
      this.showAllCostCenter = CostCenterEnums.Todos;
    }

    if (reload) {
      this.changeBussinessDocumentsType();
    }
  }

  async getButtonClick(buttonClick: any) {
    const branchId = this.formAdvanceInvoiceFirst.get("branchId")?.value;
    const enterpriseId = this.formAdvanceInvoiceFirst.get("enterpriseId")?.value;
    const bussinessDocumentsTypeId = this.formAdvanceInvoiceFirst.get("bussinessDocumentsTypeId")?.value;
    const consecutive = this.formAdvanceInvoiceFirst.get("consecutive")?.value;

    if (branchId == null || branchId == 0) {
      this.toastHandlerService.showToast(
        'warning',
        'Seleccione una sucursal.'
      );
      return;
    } else if (enterpriseId == null || enterpriseId == 0) {
      this.toastHandlerService.showToast(
        'warning',
        'Seleccione una Empresa.'
      );
      return;
    } else if (bussinessDocumentsTypeId == null || bussinessDocumentsTypeId == 0) {
      this.toastHandlerService.showToast(
        'warning',
        'Seleccione un Tipo de Documento Comercial.'
      );
      return;
    }
    switch (buttonClick.target.id) {
      case 'first': {
        try {
          this.advanceInvoiceContract = await firstValueFrom(
            this.advanceInvoiceService.getFirstAdvanceInvoiceByKeysAsync(branchId, enterpriseId, bussinessDocumentsTypeId)
          );
          this.advanceInvoiceId = this.advanceInvoiceContract.advanceInvoiceId;
          this.validateForm(this.advanceInvoiceContract);
          this.location.replaceState(`/advance-invoice/register/${this.advanceInvoiceId}`);
        } catch (error) {
          this.clearForm();
          console.error('Error al buscar la primera factura anticipada.', error);
        }
        break;
      }
      case 'previus': {
        try {
          this.advanceInvoiceContract = await firstValueFrom(
            this.advanceInvoiceService.getPreviusAdvanceInvoiceByKeysAsync(branchId, enterpriseId, bussinessDocumentsTypeId, consecutive)
          );
          this.advanceInvoiceId = this.advanceInvoiceContract.advanceInvoiceId;
          this.validateForm(this.advanceInvoiceContract);
          this.location.replaceState(`/advance-invoice/register/${this.advanceInvoiceId}`);
        } catch (error) {
          this.clearForm();
          console.error('Error al buscar la factura anticipada anterior.', error);
        }
        break;
      }
      case 'next': {
        try {
          this.advanceInvoiceContract = await firstValueFrom(
            this.advanceInvoiceService.getNextAdvanceInvoiceByKeysAsync(branchId, enterpriseId, bussinessDocumentsTypeId, consecutive)
          );
          this.advanceInvoiceId = this.advanceInvoiceContract.advanceInvoiceId;
          this.validateForm(this.advanceInvoiceContract);
          this.location.replaceState(`/advance-invoice/register/${this.advanceInvoiceId}`);
        } catch (error) {
          this.clearForm();
          console.error('Error al buscar la factura anticipada siguiente.', error);
        }
        break;
      }
      case 'last': {
        try {
          this.advanceInvoiceContract = await firstValueFrom(
            this.advanceInvoiceService.getLastAdvanceInvoiceByKeysAsync(branchId, enterpriseId, bussinessDocumentsTypeId)
          );
          this.advanceInvoiceId = this.advanceInvoiceContract.advanceInvoiceId;
          this.validateForm(this.advanceInvoiceContract);
          this.location.replaceState(`/advance-invoice/register/${this.advanceInvoiceId}`);
        } catch (error) {
          this.clearForm();
          console.error('Error al buscar la ultima factura anticipada.', error);
        }
        break;
      }
    }
  }

  getClass(selection: string): string {
    const state = selection === 'client' ? this.stateClientId : this.stateCostCenterId;
    return state === ClientStateEnums.activo ? '' : 'state-inactive';
  }

  async getConceptsAdvanceInvoiceWithPagination() {
    try {
      const response = await firstValueFrom(this.advanceInvoiceConceptService.getAdvanceInvoiceConceptsByAdvanceInvoiceIdWithPagination(
        this.page, this.limit, this.columnSort, this.ascendant, this.advanceInvoiceContract.invoiceId
      ));
      this.quantityDetails = response.totalItems;
    } catch (error) {
      console.error('Error al buscar los detalles de la factura anticipada.', error);
    }
  }

  async getEnterprise(enterpriseId: number, reload: boolean) {
    try {
      const response = await firstValueFrom(this.enterpriseService.getEnterpriseById(enterpriseId));
      this.enterpriseId = response.enterpriseId;
      if (reload) {
        await this.changeEnterprise(response.enterpriseId);
      }
    } catch (error) {
      console.error('Error al obtener la empresa.', error);
    }
  }

  async getFirstBranchByUserAuthenticatedAsync() {
    this.mainBranchByUser = await firstValueFrom(
      this.userAuthenticatedService.branchObservable.pipe(
        filter(branch => branch && branch.branchId !== 0)
      )
    );
    this.companyId = this.mainBranchByUser.companyId;
  }

  async getFirstBranchByUserAuthenticated() {
    try {
      const response = await firstValueFrom(this.branchService.getFirstBranchByUserAuthenticatedAsync());
      this.branchId = response.branchId;
      this.companyId = response.companyId;
      await this.getFirstEnterpriseByBranch();
    } catch (error) {
      console.error('Error al obtener la sucursal del usuario.', error);
    }
  }

  async getFirstBussinessDocumentsType() {
    try {
      const bussinessDocumentsClass = BussinessDocumentsClassEnums.factura;
      const response = await firstValueFrom(this.bussinessDocumentsTypeService.getFirstBussinessDocumentsType(bussinessDocumentsClass, this.enterpriseId));
      this.bussinessDocumentsTypeId = response.bussinessDocumentsTypeId;
      this.getBussinessDocumentsType(response.bussinessDocumentsTypeId, false);
    } catch (error) {
      console.error('Error al buscar el tipo de documento de la factura anticipada.', error);
    }
  }

  async getFirstEnterpriseByBranch() {
    try {
      const response = await firstValueFrom(this.enterpriseService.getFirstEnterpriseByBranch(this.branchId));
      if (!response) {
        this.enterpriseId = 0;
        this.toastHandlerService.showToast('error', 'La Sucursal no tiene empresas creadas.');
      } else {
        this.enterpriseId = response.enterpriseId;
        await this.getFirstBussinessDocumentsType();
      }
    } catch (error) {
      console.error('Error al obtener la primera empresa por sucursal.', error);
    }
  }

  async getInitialData() {
    try {
      await this.getFirstBranchByUserAuthenticated();
      await this.getAllLists();
    } catch (error) {
      console.error('Error al buscar la sucursal del usuario autenticado.', error);
    }
  }

  async getInvoicingCutoffCode(invoicingCutoffId: number | null) {
    if (invoicingCutoffId != null && invoicingCutoffId != 0) {
      this.invoicingCutoffCode = await firstValueFrom(this.invoiceService.getInvoicingCutoffCodeByIdAsync(invoicingCutoffId));
    } else {
      this.invoicingCutoffCode = "";
    }
  }

  async getPermission() {
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      this.isOpened = windowsOpened.find(x => x === this.url);
      windowsOpened.push(this.url);
      localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      if (this.isOpened) {
        this.toastHandlerService.showToast(
          'warning',
          `No se permite tener dos ventanas/pestañas de ${this.nameWindow} abiertas.`
        );
      }
    } else {
      localStorage.clear();
    }
    await this.getUserAuthenticated();
    await Promise.all([
      this.getPermissionProfileByUrl(),
      this.getPermissionsForUserByWindow()
    ]);
  }

  async getPermissionProfileByUrl() {
    try {
      this.permissionUpdatable = await firstValueFrom(this.windowService.getPermissionProfileByUrl(this.url));
    } catch (error) {
      console.error('Error al buscar los permisos del perfil.', error);
    }
  }

  async getPermissionsForUserByWindow() {
    try {
      this.permissionsUser = await firstValueFrom(this.optionWindowService.getPermissionsForUserByWindow(WindowEnums.AdvanceInvoice));
    } catch (error) {
      console.error('Error al buscar los permisos para el usuario.', error);
    }
  }

  getUpdateAdvanceInvoice(advanceInvoice: AdvanceInvoiceModel) {
    this.advanceInvoiceContract = advanceInvoice;
    this.validateForm(this.advanceInvoiceContract);
  }

  async getUserAuthenticated() {
    try {
      const response = await firstValueFrom(this.userAuthenticatedService.userObservable.pipe(filter(user => user && user.userId !== 0)));
      this.companyId = response.companyId;
      this.userAuthenticated = response;
    } catch (error) {
      console.error('Error al obtener el usuario autenticado:', error);
    }
  }

  async handleInitialState() {
    if (this.advanceInvoiceId) {
      await this.editAdvanceInvoice();
    } else {
      await this.getInitialData();
    }
  }

  async onPageChange(event: { page: number; pageSize: number, sortField: string | undefined, sortOrder: number }) {
    this.page = event.page;
    this.limit = event.pageSize;
    this.columnSort = event.sortField || null;
    this.ascendant = event.sortOrder === 1;
    this.getConceptsAdvanceInvoiceWithPagination();
  }

  async setClient(clientId: number | null) {
    this.filterCostCenterByClientId(clientId);
    if (clientId != null && clientId != 0) {
      const client = await firstValueFrom(this.invoiceService.getClientByIdForRegisterInvoiceAsync(clientId));
      this.clientId = clientId;
      this.stateClientId = client.clientStateId as number | null;

      const exist = this.listClients.some(c => c.value === this.clientId);
      if (!exist) {
        this.listClients.push({ label: client.label, value: this.clientId });
      }

      this.formAdvanceInvoiceFirst.controls["clientId"].patchValue(this.clientId);
    }
  }

  async setCostCenter(costCenterId: number | null) {
    if (costCenterId != null && costCenterId != 0) {
      const costCenterModel = await firstValueFrom(this.costCenterService.getCostCenterById(costCenterId));
      this.stateCostCenterId = costCenterModel.constructionSite.constructionSiteStateId;

      const exist = this.listCostCenters.some(c => c.value == costCenterId);
      if (!exist && costCenterModel) {
        this.listCostCenters.push({ clientId: costCenterModel.clientId, label: `${costCenterModel.code} - ${costCenterModel.name}`, value: costCenterId });
      }
      this.formAdvanceInvoiceFirst.controls["costCenterId"].patchValue(costCenterId);
    }
  }

  toggleAccordion() {
    this.showAccordion = !this.showAccordion;
    this.isFormView = false;
  }

  async updateFormState() {
    setTimeout(() => this.formAdvanceInvoiceFirst.disable(), 100);
    switch (this.advanceInvoiceContract.advanceInvoiceState) {
      case AdvanceInvoiceStateEnums.open: {
        this.severityState = 'danger',
          this.iconStateAdvanceInvoice = 'pi pi-lock-open',
          this.titleStateAdvanceInvoice = 'Cerrar';
        this.advanceInvoiceStateString = "Abierta";
        break;
      }
      case AdvanceInvoiceStateEnums.closed: {
        this.severityState = 'success',
          this.iconStateAdvanceInvoice = 'pi pi-lock',
          this.titleStateAdvanceInvoice = 'Abrir';
        this.advanceInvoiceStateString = "Cerrada";
        break;
      }
    }
    if (this.advanceInvoiceContract.advanceInvoiceState == AdvanceInvoiceStateEnums.open) {
      this.disabledForm = false;
      if (this.advanceInvoiceId != 0) {
        setTimeout(() => this.formControlStateService.setControlState(
          this.formAdvanceInvoiceFirst, ['branchId', 'enterpriseId', 'bussinessDocumentsTypeId', 'consecutive'], true
        ), 100);
      } else {
        setTimeout(() => this.formAdvanceInvoiceFirst.controls["consecutive"].disable(), 100);
      }
    } else {
      this.disabledForm = true;
      setTimeout(() => this.formControlStateService.setControlState(
        this.formAdvanceInvoiceFirst, ['branchId', 'enterpriseId', 'bussinessDocumentsTypeId', 'consecutive'], true
      ), 100);
    }

    if (!this.permissionUpdatable) setTimeout(() => this.formAdvanceInvoiceFirst.disable(), 100);
  }

  async validateForm(advanceInvoice: AdvanceInvoiceModel) {
    this.formAdvanceInvoiceFirst = this.formBuilder.group({
      branchId: [advanceInvoice.branchId, [Validators.required, Validators.min(1)]],
      enterpriseId: [advanceInvoice.invoice.enterpriseId, [Validators.required, Validators.min(1)]],
      bussinessDocumentsTypeId: [advanceInvoice.invoice.bussinessDocumentsTypeId, [Validators.required, Validators.min(1)]],
      bussinessDocumentsTypeIsRental: [advanceInvoice.invoice.bussinessDocumentsTypeIsRental],
      consecutive: [advanceInvoice.invoice.consecutive, [Validators.required]],
      conceptTypeDIANId: [advanceInvoice.invoice.conceptTypeDIANId, [Validators.required]],
      dateInvoice: [advanceInvoice.invoice.dateInvoice ? this.dateConverterService.convertDatePreserveDay(advanceInvoice.invoice.dateInvoice) : null, [Validators.required]],
      clientId: [advanceInvoice.invoice.clientId, [Validators.required, Validators.min(1)]],
      costCenterId: [advanceInvoice.invoice.costCenterId],
      swInvoiceDifference: [{ value: advanceInvoice.swInvoiceDifference, disabled: true }],
      zoneId: [advanceInvoice.invoice.zoneId, [Validators.required, Validators.min(1)]],
      sellerId: [advanceInvoice.invoice.sellerId, [Validators.required, Validators.min(1)]]
    });

    this.formAdvanceInvoiceFooter = this.formBuilder.group({
      subtotalValue: [{ value: advanceInvoice.invoice.subtotalValue, disabled: true }, [Validators.min(0), Validators.max(99999999999.99)]],
      discountValue: [{ value: advanceInvoice.invoice.discountValue, disabled: true }, [Validators.min(0), Validators.max(99999999999.99)]],
      ivaValue: [{ value: advanceInvoice.invoice.ivaValue, disabled: true }, [Validators.min(0), Validators.max(99999999999.99)]],
      totalValue: [{ value: advanceInvoice.invoice.totalValue, disabled: true }, [Validators.min(0), Validators.max(99999999999.99)]]
    });

    if (advanceInvoice.invoiceId != 0) {
      this.getBussinessDocumentsType(advanceInvoice.invoice.bussinessDocumentsTypeId, false);
      await this.setClient(advanceInvoice.invoice.clientId);
      await this.setCostCenter(advanceInvoice.invoice.costCenterId);
      this.getInvoicingCutoffCode(advanceInvoice.invoicingCutoffId);
      this.getConceptsAdvanceInvoiceWithPagination();
    }
    this.updateFormState()
  }

}
